export default "https://cdn-static.gokick.com/assets/5d59d840aa8978759fe32f9d0593dfb9088da5d0/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";